// CSS Modules - component class name prefix: ResultTeaser__

<template>
  <figure :class="$style.container">
    <template v-if="isVideo">
      <a
        v-if="result._source.image"
        :class="$style.imageLink"
        @click="isModalOpen = true"
      >
        <div
          :class="$style.bgImage"
          :style="{ backgroundImage: `url(${result._source.image})` }"
        >
          <img :src="result._source.image" :alt="result._source.title" />
          <i
            v-if="result._source.archived"
            :class="['fa fa-archive', $style.archived]"
          />
        </div>
      </a>
      <figcaption>
        <a :class="$style.textLink" @click="isModalOpen = true">
          <div
            v-if="result._source.breadcrumb"
            :class="$style.path"
            v-html="`${result._source.breadcrumb.replace(/\,/g, ' > ')}`"
          ></div>
          <div v-else :class="$style.path">
            {{ result._source.categorylabel }}
          </div>
          <h3 v-html="getTitleWithMaxLength(result)"></h3>
          <div
            v-if="result.highlight && result.highlight.description"
            v-html="getDescriptionWithMaxLength(result)"
          ></div>
          <div :class="$style.url">{{ resultUrl }}</div>
        </a>
      </figcaption>
      <Modal
        :isModalOpen="isModalOpen"
        :isVideo="isVideo"
        @closeModal="isModalOpen = false"
      >
        <iframe
          :src="resultUrl + '?enablejsapi=1'"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </Modal>
    </template>
    <template v-else>
      <a
        v-if="result._source.image"
        :class="$style.imageLink"
        :href="resultUrl"
        :target="getLinkTarget()"
      >
        <div
          :class="$style.bgImage"
          :style="{ backgroundImage: `url(${result._source.image})` }"
        >
          <img :src="result._source.image" :alt="result._source.title" />
          <i
            v-if="result._source.archived"
            :class="['fa fa-archive', $style.archived]"
          />
        </div>
      </a>
      <figcaption>
        <a :class="$style.textLink" :href="resultUrl" :target="getLinkTarget()">
          <div
            v-if="result._source.breadcrumb"
            :class="$style.path"
            v-html="`${result._source.breadcrumb.replace(/\,/g, ' > ')}`"
          ></div>
          <div v-else :class="$style.path">
            {{ result._source.categorylabel }}
          </div>
          <h3 v-html="getTitleWithMaxLength(result)"></h3>
          <div v-html="getDescriptionWithMaxLength(result)"></div>
          <div :class="$style.url">{{ resultUrl }}</div>
        </a>
      </figcaption>
    </template>
  </figure>
</template>

<script>
import Modal from "../Modal/Modal.vue";
import { Category, DocType } from "../../globals/constants/search";

export default {
  name: "ResultTeaser",
  components: {
    Modal
  },
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    webBaseUrl: {
      type: String,
      default: ""
    },
    shopBaseUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      resultUrl: "",
      isModalOpen: false,
      isVideo: false
    };
  },
  methods: {
    getLinkTarget() {
      return this.result._source.categoryuid === Category.DOWNLOAD ||
        this.result._source.docType === DocType.BLOG
        ? "_blank"
        : "_self";
    },
    getTitleWithMaxLength(result) {
      if (result.highlight && result.highlight.title) {
        return result.highlight.title.join(" ");
      } else if (result._source.description) {
        return result._source.title;
      }
    },
    getDescriptionWithMaxLength(result) {
      if (result.highlight && result.highlight.description) {
        return this.cropTextIfTooLong(result.highlight.description.join(" "));
      } else if (result._source.description) {
        return this.cropTextIfTooLong(result._source.description);
      }
    },
    cropTextIfTooLong(description) {
      const DESCRIPTION_MAX_LENGTH = 160;
      return description.length > DESCRIPTION_MAX_LENGTH
        ? description.substring(0, DESCRIPTION_MAX_LENGTH) + "..."
        : description;
    },
    setResultUrlWithOptionalPrefix(path, baseUrl) {
      if (path.indexOf("http") === 0) {
        this.resultUrl = this.result._source.path;
      } else {
        this.resultUrl = baseUrl + this.result._source.path;
      }
    },
    preprocessResultCategory() {
      switch (this.result._source.categoryuid) {
        case Category.SHOP:
          this.setResultUrlWithOptionalPrefix(
            this.result._source.path,
            this.shopBaseUrl
          );
          break;
        case Category.VIDEOS:
          this.resultUrl = this.result._source.path;
          this.isVideo = true;
          break;
        case Category.BLOG:
          this.resultUrl = this.result._source.path;
          break;
        default:
          this.setResultUrlWithOptionalPrefix(
            this.result._source.path,
            this.webBaseUrl
          );
          break;
      }
    }
  },
  mounted() {
    if (this.result._source) {
      this.preprocessResultCategory();
    }
  }
};
</script>

<style module lang="scss">
@import "./ResultTeaser.scss";
</style>
